import { render, staticRenderFns } from "./LessonChatInsertComponent.vue?vue&type=template&id=5b9eb698&scoped=true&"
import script from "./LessonChatInsertComponent.vue?vue&type=script&lang=js&"
export * from "./LessonChatInsertComponent.vue?vue&type=script&lang=js&"
import style0 from "./LessonChatInsertComponent.vue?vue&type=style&index=0&id=5b9eb698&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b9eb698",
  null
  
)

export default component.exports